// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-contaniner[data-v-82a4bf1c]{\n  margin: 20px 0 0;\n}\n", ""]);
// Exports
module.exports = exports;
